import {Field} from 'redux-form'
import styles from './style.css'
import {assignToIngredientGetIngredientsRequest} from 'actions/ingredients/category'
import {connect} from 'react-redux'

class Search extends React.Component {
  render () {
    return (
      <div className={`row ${styles.wrapper}`}>
        <div className='col-md-12'>
          <div className='right-inner-addon'>
            <i className={'fa fa-search ' + styles.right} />
            <Field
              component='input'
              name='keyword'
              className='form-control'
              placeholder='search'
              onChange={this._onChange}
            />
          </div>
        </div>
      </div>
    )
  }

  _onChange = (event, value) => {
    this.props.dispatch(assignToIngredientGetIngredientsRequest({page: 1, keyword: value, with_batch: true}, []))
  }
}

function mapStateToProps (state) {
  return {}
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Category/AssignToIngredientModal/Search/Search.js